export const WebUiRegCfOverviewEnI18n = {
    descr: `The Investment limit for this Reg CF offering was calculated based on the financial data you provided.`,
    updateCtaText: `Update my limit`,
};
